import {
  type Ref,
  watch,
} from 'vue';
import { useRouter } from 'vue-router';

const useCompsetCountWatcher = (compsetsRef: Ref) => {
  const router = useRouter();

  watch(compsetsRef, () => {
    router.replace({ params: { itemCount: compsetsRef.value.length } });
  }, { immediate: true });
};

export default useCompsetCountWatcher;
